import React from "react";
import AdminSettingsMaster from "../components/AdminSettings/AdminSettingsMaster";

const AdminSettings = () => {
  return (
    <>
      <AdminSettingsMaster />
    </>
  );
};
export default AdminSettings;
